/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkMusicFill: {
  name: 'bookmark-music-fill';
  data: string;
} = {
  name: 'bookmark-music-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v15.674a2 2 0 0 0 2.55 1.923L12 20.04l5.45 1.557A2 2 0 0 0 20 19.674V4a2 2 0 0 0-2-2H6Zm10.316 5.949a1 1 0 1 0-.632-1.897l-2.316.772A2 2 0 0 0 12 8.72v1.45a3 3 0 1 0 2 2.833V8.72l2.316-.772ZM12 13a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" fill="currentColor"/></svg>`,
};
